module.exports = __webpack_public_path__ + "static/media/truck-loading.3d0b7586.svg";